var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 1.25H3.75C3.4043 1.25 3.125 1.5293 3.125 1.875V18.125C3.125 18.4707 3.4043 18.75 3.75 18.75H16.25C16.5957 18.75 16.875 18.4707 16.875 18.125V1.875C16.875 1.5293 16.5957 1.25 16.25 1.25ZM15.4688 17.3438H4.53125V13.418H6.44336C6.66992 14.0586 7.06836 14.6348 7.59766 15.0723C8.27148 15.6289 9.125 15.9375 10 15.9375C10.875 15.9375 11.7285 15.6309 12.4023 15.0723C12.9316 14.6348 13.3301 14.0586 13.5566 13.418H15.4688V12.1875H12.5703L12.4688 12.6699C12.2344 13.8379 11.1953 14.6875 10 14.6875C8.80469 14.6875 7.76563 13.8379 7.5293 12.6699L7.42773 12.1875H4.53125V2.65625H15.4688V17.3438ZM6.25 6.66016H13.75C13.8359 6.66016 13.9062 6.58984 13.9062 6.50391V5.56641C13.9062 5.48047 13.8359 5.41016 13.75 5.41016H6.25C6.16406 5.41016 6.09375 5.48047 6.09375 5.56641V6.50391C6.09375 6.58984 6.16406 6.66016 6.25 6.66016ZM6.25 9.78516H13.75C13.8359 9.78516 13.9062 9.71484 13.9062 9.62891V8.69141C13.9062 8.60547 13.8359 8.53516 13.75 8.53516H6.25C6.16406 8.53516 6.09375 8.60547 6.09375 8.69141V9.62891C6.09375 9.71484 6.16406 9.78516 6.25 9.78516Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/Billing.69dee84cd1d72423f3831ba1c8b4e6d8.svg";
export { ForwardRef as ReactComponent };